// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MainRouteImport } from './routes/_main'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as NoAccessIndexRouteImport } from './routes/no-access/index'
import { Route as MaintenanceIndexRouteImport } from './routes/maintenance/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as PRefRouteImport } from './routes/p/$ref'
import { Route as MainTradeRouteRouteImport } from './routes/_main/trade/route'
import { Route as MainTrackersRouteRouteImport } from './routes/_main/trackers/route'
import { Route as MainDashboardRouteRouteImport } from './routes/_main/dashboard/route'
import { Route as SharePositionIdVersionRouteImport } from './routes/share/$positionId.$version'
import { Route as MainWalletsIndexRouteImport } from './routes/_main/wallets/index'
import { Route as MainWalletIndexRouteImport } from './routes/_main/wallet/index'
import { Route as MainReferralIndexRouteImport } from './routes/_main/referral/index'
import { Route as MainPumpIndexRouteImport } from './routes/_main/pump/index'
import { Route as MainPortfolioIndexRouteImport } from './routes/_main/portfolio/index'
import { Route as MainPerpetualsIndexRouteImport } from './routes/_main/perpetuals/index'
import { Route as MainMonacoPerpetualsIndexRouteImport } from './routes/_main/monaco-perpetuals/index'
import { Route as MainExploreIndexRouteImport } from './routes/_main/explore/index'
import { Route as MainCopyTradingIndexRouteImport } from './routes/_main/copy-trading/index'
import { Route as MainTokenTokenIdRouteImport } from './routes/_main/token/$tokenId'
import { Route as MainPerpetualsCoinRouteImport } from './routes/_main/perpetuals/$coin'
import { Route as MainMonacoPerpetualsCoinRouteImport } from './routes/_main/monaco-perpetuals/$coin'
import { Route as MainTrackersIndexRouteImport } from './routes/_main/trackers/index'
import { Route as MainDashboardIndexRouteImport } from './routes/_main/dashboard/index'
import { Route as MainDashboardLeaderboardRouteImport } from './routes/_main/dashboard/leaderboard'
import { Route as AuthLoginGoogleRouteImport } from './routes/auth/login.google'
import { Route as AuthLoginDiscordRouteImport } from './routes/auth/login.discord'
import { Route as MainTradeChainAddressRouteImport } from './routes/_main/trade/$chain.$address'
import { Route as MainTrackersWalletsIndexRouteImport } from './routes/_main/trackers/wallets/index'
import { Route as MainTrackersTwitterIndexRouteImport } from './routes/_main/trackers/twitter/index'
import { Route as MainDashboardProgressIndexRouteImport } from './routes/_main/dashboard/progress/index'

const MainRoute = MainRouteImport.update({
            id: '/_main',getParentRoute: () => rootRouteImport
          })
const AuthRouteRoute = AuthRouteRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const NoAccessIndexRoute = NoAccessIndexRouteImport.update({
            id: '/no-access/',path: '/no-access/',getParentRoute: () => rootRouteImport
          })
const MaintenanceIndexRoute = MaintenanceIndexRouteImport.update({
            id: '/maintenance/',path: '/maintenance/',getParentRoute: () => rootRouteImport
          })
const LoginIndexRoute = LoginIndexRouteImport.update({
            id: '/login/',path: '/login/',getParentRoute: () => rootRouteImport
          })
const PRefRoute = PRefRouteImport.update({
            id: '/p/$ref',path: '/p/$ref',getParentRoute: () => rootRouteImport
          })
const MainTradeRouteRoute = MainTradeRouteRouteImport.update({
            id: '/trade',path: '/trade',getParentRoute: () => MainRoute
          })
const MainTrackersRouteRoute = MainTrackersRouteRouteImport.update({
            id: '/trackers',path: '/trackers',getParentRoute: () => MainRoute
          })
const MainDashboardRouteRoute = MainDashboardRouteRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => MainRoute
          })
const SharePositionIdVersionRoute = SharePositionIdVersionRouteImport.update({
            id: '/share/$positionId/$version',path: '/share/$positionId/$version',getParentRoute: () => rootRouteImport
          })
const MainWalletsIndexRoute = MainWalletsIndexRouteImport.update({
            id: '/wallets/',path: '/wallets/',getParentRoute: () => MainRoute
          })
const MainWalletIndexRoute = MainWalletIndexRouteImport.update({
            id: '/wallet/',path: '/wallet/',getParentRoute: () => MainRoute
          })
const MainReferralIndexRoute = MainReferralIndexRouteImport.update({
            id: '/referral/',path: '/referral/',getParentRoute: () => MainRoute
          })
const MainPumpIndexRoute = MainPumpIndexRouteImport.update({
            id: '/pump/',path: '/pump/',getParentRoute: () => MainRoute
          })
const MainPortfolioIndexRoute = MainPortfolioIndexRouteImport.update({
            id: '/portfolio/',path: '/portfolio/',getParentRoute: () => MainRoute
          })
const MainPerpetualsIndexRoute = MainPerpetualsIndexRouteImport.update({
            id: '/perpetuals/',path: '/perpetuals/',getParentRoute: () => MainRoute
          })
const MainMonacoPerpetualsIndexRoute = MainMonacoPerpetualsIndexRouteImport.update({
            id: '/monaco-perpetuals/',path: '/monaco-perpetuals/',getParentRoute: () => MainRoute
          })
const MainExploreIndexRoute = MainExploreIndexRouteImport.update({
            id: '/explore/',path: '/explore/',getParentRoute: () => MainRoute
          })
const MainCopyTradingIndexRoute = MainCopyTradingIndexRouteImport.update({
            id: '/copy-trading/',path: '/copy-trading/',getParentRoute: () => MainRoute
          })
const MainTokenTokenIdRoute = MainTokenTokenIdRouteImport.update({
            id: '/token/$tokenId',path: '/token/$tokenId',getParentRoute: () => MainRoute
          })
const MainPerpetualsCoinRoute = MainPerpetualsCoinRouteImport.update({
            id: '/perpetuals/$coin',path: '/perpetuals/$coin',getParentRoute: () => MainRoute
          })
const MainMonacoPerpetualsCoinRoute = MainMonacoPerpetualsCoinRouteImport.update({
            id: '/monaco-perpetuals/$coin',path: '/monaco-perpetuals/$coin',getParentRoute: () => MainRoute
          })
const MainTrackersIndexRoute = MainTrackersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MainTrackersRouteRoute
          })
const MainDashboardIndexRoute = MainDashboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MainDashboardRouteRoute
          })
const MainDashboardLeaderboardRoute = MainDashboardLeaderboardRouteImport.update({
            id: '/leaderboard',path: '/leaderboard',getParentRoute: () => MainDashboardRouteRoute
          })
const AuthLoginGoogleRoute = AuthLoginGoogleRouteImport.update({
            id: '/login/google',path: '/login/google',getParentRoute: () => AuthRouteRoute
          })
const AuthLoginDiscordRoute = AuthLoginDiscordRouteImport.update({
            id: '/login/discord',path: '/login/discord',getParentRoute: () => AuthRouteRoute
          })
const MainTradeChainAddressRoute = MainTradeChainAddressRouteImport.update({
            id: '/$chain/$address',path: '/$chain/$address',getParentRoute: () => MainTradeRouteRoute
          })
const MainTrackersWalletsIndexRoute = MainTrackersWalletsIndexRouteImport.update({
            id: '/wallets/',path: '/wallets/',getParentRoute: () => MainTrackersRouteRoute
          })
const MainTrackersTwitterIndexRoute = MainTrackersTwitterIndexRouteImport.update({
            id: '/twitter/',path: '/twitter/',getParentRoute: () => MainTrackersRouteRoute
          })
const MainDashboardProgressIndexRoute = MainDashboardProgressIndexRouteImport.update({
            id: '/progress/',path: '/progress/',getParentRoute: () => MainDashboardRouteRoute
          })





const AuthRouteRouteChildren = {
  AuthLoginDiscordRoute: AuthLoginDiscordRoute,AuthLoginGoogleRoute: AuthLoginGoogleRoute
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(AuthRouteRouteChildren)




const MainDashboardRouteRouteChildren = {
  MainDashboardLeaderboardRoute: MainDashboardLeaderboardRoute,MainDashboardIndexRoute: MainDashboardIndexRoute,MainDashboardProgressIndexRoute: MainDashboardProgressIndexRoute
}

const MainDashboardRouteRouteWithChildren = MainDashboardRouteRoute._addFileChildren(MainDashboardRouteRouteChildren)




const MainTrackersRouteRouteChildren = {
  MainTrackersIndexRoute: MainTrackersIndexRoute,MainTrackersTwitterIndexRoute: MainTrackersTwitterIndexRoute,MainTrackersWalletsIndexRoute: MainTrackersWalletsIndexRoute
}

const MainTrackersRouteRouteWithChildren = MainTrackersRouteRoute._addFileChildren(MainTrackersRouteRouteChildren)




const MainTradeRouteRouteChildren = {
  MainTradeChainAddressRoute: MainTradeChainAddressRoute
}

const MainTradeRouteRouteWithChildren = MainTradeRouteRoute._addFileChildren(MainTradeRouteRouteChildren)



const MainRouteChildren = {
  MainDashboardRouteRoute: MainDashboardRouteRouteWithChildren,MainTrackersRouteRoute: MainTrackersRouteRouteWithChildren,MainTradeRouteRoute: MainTradeRouteRouteWithChildren,MainMonacoPerpetualsCoinRoute: MainMonacoPerpetualsCoinRoute,MainPerpetualsCoinRoute: MainPerpetualsCoinRoute,MainTokenTokenIdRoute: MainTokenTokenIdRoute,MainCopyTradingIndexRoute: MainCopyTradingIndexRoute,MainExploreIndexRoute: MainExploreIndexRoute,MainMonacoPerpetualsIndexRoute: MainMonacoPerpetualsIndexRoute,MainPerpetualsIndexRoute: MainPerpetualsIndexRoute,MainPortfolioIndexRoute: MainPortfolioIndexRoute,MainPumpIndexRoute: MainPumpIndexRoute,MainReferralIndexRoute: MainReferralIndexRoute,MainWalletIndexRoute: MainWalletIndexRoute,MainWalletsIndexRoute: MainWalletsIndexRoute
}

const MainRouteWithChildren = MainRoute._addFileChildren(MainRouteChildren)

const rootRouteChildren = {
  AuthRouteRoute: AuthRouteRouteWithChildren,MainRoute: MainRouteWithChildren,PRefRoute: PRefRoute,LoginIndexRoute: LoginIndexRoute,MaintenanceIndexRoute: MaintenanceIndexRoute,NoAccessIndexRoute: NoAccessIndexRoute,SharePositionIdVersionRoute: SharePositionIdVersionRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)